import { ChevronDown } from "lucide-react";
import { forwardRef } from "react";

const SELECT_THEME_CLASSES = {
  cloud:
    "border-navy-blue-04 bg-navy-blue-05 hover:border-navy-blue-03 focus:border-navy-blue-03 focus:bg-navy-blue-04 valid:bg-navy-blue-05 valid:border-navy-blue-04 [&>option]:bg-navy-blue-05",
  zerto:
    "border-zerto-blue-07 bg-zerto-blue-08 hover:border-zerto-blue-06 focus:bg-zerto-blue-07 valid:bg-zerto-blue-08 valid:border-zerto-blue-07 hover:text-white active:text-white valid:text-white [&>option]:bg-zerto-blue-08",
};

const SelectV2 = forwardRef(
  (
    {
      children,
      label,
      style = "",
      error,
      icon,
      iconClassName = "",
      theme = "cloud",
      ...rest
    },
    ref,
  ) => {
    const stateClasses =
      SELECT_THEME_CLASSES[theme] || SELECT_THEME_CLASSES.cloud;

    return (
      <div>
        <div className="select-wrapper">
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
              <div className="relative">
                {icon && (
                  <img
                    src={icon}
                    alt="icon"
                    className={` ${iconClassName} absolute top-1/2 -translate-y-1/2 left-3 size-4 md:size-[18px]`}
                  />
                )}
                <select
                  ref={ref}
                  className={`font-inter cursor-pointer py-3 ps-10 pe-11 rounded-lg border text-grey-03 outline-none w-full disabled:opacity-70 disabled:cursor-not-allowed [&>option]:text-grey-03 ${stateClasses} ${style}`}
                  {...rest}
                >
                  {children}
                </select>
                <ChevronDown className="absolute top-1/2 translate-y-[-50%] right-5 text-grey-03" />
              </div>
              {error && <p className="text-red text-xs text-start">{error}</p>}
            </div>
          </div>
        </div>
      </div>
    );
  },
);

export default SelectV2;
